import React, { useState , useEffect} from 'react'
import ReusableDiv from 'src/helper/ReusableDiv'
import System from 'src/helper/system'
import Helper from 'src/helper/Helper'
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import { useDesignHubStore } from "src/hooks/designHub";
import Constants from "src/helper/Constants";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const Registration = () => {
    const [detailValidation, setDetailValidation] = useState({});
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { }, { register_user }] = useDesignHubStore();

    const modal = {
        company_name: "",
        telephone_number: "",
        first_name: "",
        last_name: "",
        email_address: "",
        email_updates: System.getCookie("_mkto_trk") !== undefined ? true : false,
        mkto_trk: System.getCookie("_mkto_trk") || "",
        speedboat: Constants.speedBoats.americaAbbr
    }
    const [userDetail, setUserDetail] = useState(modal);
    const emailSpecialCharPattern = /^[a-zA-Z0-9]+(?:[_.+%-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[_.+%-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
    const [confirmEmail, setConfirmEmail] = useState("")

    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            field === 'confirmEmail' ? delete detailValidation.confirm_email : delete detailValidation[field]
        }
        field === 'confirmEmail' ? setConfirmEmail(value) : setUserDetail({ ...userDetail, [field]: value });
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(userDetail.company_name) ? "" : validationModal.company_name = "Please enter a company name.";

        Helper.valueIsNotNull(userDetail.telephone_number) ? (!Helper.validateRegex(userDetail.telephone_number, Constants.numericWithSpecialChar) ? validationModal.telephone_number = "Please enter a valid phone number." : "") : validationModal.telephone_number = "Please enter a valid phone number.";

        Helper.valueIsNotNull(userDetail.first_name) ? (userDetail.first_name?.length < 3 ? validationModal.first_name = "First name must not be less than 3 characters" : "") : validationModal.first_name = "Please enter a first name.";

        Helper.valueIsNotNull(userDetail.last_name) ? (userDetail.last_name?.length < 3 ? validationModal.last_name = "Last name must not be less than 3 characters" : "") : validationModal.last_name = "Please enter last name.";

        Helper.valueIsNotNull(confirmEmail) ? (userDetail?.email_address?.toLocaleLowerCase() === confirmEmail?.toLocaleLowerCase() ? '' : validationModal.confirm_email = "Your Email ID does not match. Please Re-enter the Email ID.") :
            validationModal.confirm_email = 'Please enter valid email address.'

        Helper.valueIsNotNull(userDetail.email_address) ? (!Helper.validateRegex(userDetail.email_address, emailSpecialCharPattern) ? validationModal.email_address = 'A valid email address is required.' : "") :
            validationModal.email_address = 'Please enter valid email address.'

        setDetailValidation(validationModal)
        return Object.keys(validationModal).length > 0 ? false : true;
    }

    const onSubmit = async () => {
        let isValid = onValidateData();

        if (isValid) {
            __set('REGISTRATION_API_CALL')
            let validationModal = {}

            const res = await register_user(userDetail)
            if (res && res.isSuccessFull) {
                System.popup('ThankYouPopup', { isRegister: true });
                registerationEvent("complete",res);
            } else if (res?.errorCode === Constants.errorCode) {
                validationModal.email_address = 'This account already exists. Please enter a new email address.'
                setDetailValidation(validationModal)
            } else if (res.status === 400) {
                validationModal.company_name = res?.errors?.company_name?.[0]
                validationModal.telephone_number = res?.errors?.telephone_number?.[0]
                validationModal.first_name = res?.errors?.first_name?.[0]
                validationModal.last_name = res?.errors?.last_name?.[0]
                validationModal.email_address = res?.errors?.email_address?.[0]
                validationModal.confirmEmail = res?.errors?.confirmEmail?.[0]
                setDetailValidation(validationModal)
            }
            else {
                if (res && res.ErrorCode && res.Message) {
                    if (res?.ErrorCode === '422') {
                        validationModal.email_address = "Please use your windows credentials to login to the Avnet Digital portal."
                        setDetailValidation(validationModal)
                    }
                }
            }
            __remove('REGISTRATION_API_CALL')
        }
        // added by Ramya
        else {
            formEvent("formErrorEvent",validationModal);
        }
    }

    const test = () => {
        System.popup('BomDeletePopup', { single_bom: {} })
    }

     //By Ramya Kannan [Registeration start,complete - Adobe script ]

     useEffect(() => {
        registerationEvent("start");
        formEvent("formStartEvent");
    }, [])

     function registerationEvent(type,res){
        let registrationType = type == "start" ? "registrationStart" : "registrationComplete";
        localStorage.setItem("adobeEventType",registrationType);
        HelperAdobeEvent.trackingAdobeEvent(res);
    }

   //By Ramya Kannan [form start,Error event - Adobe script]
   function formEvent(eventType,errorDetails){
       localStorage.setItem("adobeEventType",eventType);
       console.log("errorDetails",errorDetails)
       let formDetails = {
           formName : "Register",
           formType : "Registeration",
           formId : ""
       }
       HelperAdobeEvent.trackingAdobeEvent({formDetails});
   }

    return (
        <div>
            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
            <div className='register-container'>
                <div className='white-bg'>

                    {ReusableDiv.PopupTitle("Join Now")}
                    <div>
                        <form>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="company_name" className='d-block'>Company Name*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.company_name ? ' error' : ''}`} id="company_name"
                                            placeholder="Company Name" name="company_name"
                                            value={userDetail.company_name}
                                            maxLength={100}
                                            onChange={({ target: { value } }) => onValueChange('company_name', value)} />
                                        {detailValidation.company_name && <p className="error"> {detailValidation.company_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="telephone_number" className='d-block'>Phone Number*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.telephone_number ? ' error' : ''}`} id="telephone_number"
                                            placeholder="Phone Number" name="telephone_number"
                                            value={userDetail.telephone_number}
                                            maxLength={32}
                                            onChange={({ target: { value } }) => onValueChange('telephone_number', value)} />
                                        {detailValidation.telephone_number && <p className="error"> {detailValidation.telephone_number}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="first_name" className='d-block'>First Name*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.first_name ? ' error' : ''}`} id="first_name"
                                            placeholder="First Name" name="first_name"
                                            value={userDetail.first_name}
                                            onChange={({ target: { value } }) => onValueChange('first_name', value)} maxLength={50} />
                                        {detailValidation.first_name && <p className="error"> {detailValidation.first_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="last_name" className='d-block'>Last Name*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.last_name ? ' error' : ''}`} id="last_name"
                                            placeholder="Last Name" name="last_name"
                                            value={userDetail.last_name}
                                            onChange={({ target: { value } }) => onValueChange('last_name', value)} maxLength={50} />
                                        {detailValidation.last_name && <p className="error"> {detailValidation.last_name}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="email_address" className='d-block'>Email Address*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.email_address ? ' error' : ''}`} id="email_address"
                                            placeholder="Email Address" name="email_address"
                                            value={userDetail.email_address}
                                            onChange={({ target: { value } }) => onValueChange('email_address', value)} maxLength={50} />
                                        {detailValidation.email_address && <p className="error"> {detailValidation.email_address}</p>}
                                    </div>
                                </div>
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="confirmEmail" className='d-block'>Confirm Email*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.confirm_email ? ' error' : ''}`} id="confirmEmail"
                                            placeholder="Email Address" name="confirmEmail"
                                            value={confirmEmail}
                                            onChange={({ target: { value } }) => onValueChange('confirmEmail', value)} maxLength={50} />
                                        {detailValidation.confirm_email && <p className="error"> {detailValidation.confirm_email}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className='mb-3 d-flex align-items-center text-black'>
                                <input type="checkbox" className="form-check-input mt-0 me-2" id="customCheck1" name="email_updates" checked={userDetail.email_updates}
                                    onChange={({ target: { checked } }) => onValueChange('email_updates', checked)} />
                                <label for="customCheck1" className='cursor-pointer mb-0'>Receive updates from Avnet? </label>
                            </div>
                            {/* <div className='mb-3 text-black'>
                                <div className='d-flex align-items-center'>
                                    <input type="checkbox" className={`form-check-input mt-0  me-2 ${detailValidation?.accept_soa_terms ? ' error' : ''}`} id="customCheck2" name="accept_soa_terms"
                                        onChange={({ target: { checked } }) => onValueChange('accept_soa_terms', checked)} />
                                    <label for="customCheck2" className='cursor-pointer mb-0'>Accept SoA terms to Register. </label>&nbsp;
                                    <a target={"_blank"} href={System.getSOATerms()}>View SoA terms</a> *
                                </div>
                                {detailValidation.accept_soa_terms && <p className="error"> {detailValidation.accept_soa_terms}</p>}
                            </div> */}

                            <p className='text-black'>By registering, you agree to our {' '}
                                <a target={"_blank"} href={System.getTermsAndConditionURL()}>Terms and Conditions</a> and {' '}
                                <a target={"_blank"} href={System.getPrivacyURL()}>Privacy Statement</a>
                            </p>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center mt-5 mb-4">
                        <button type="button" className="bs5 btn btn-secondary w145" onClick={() => { if (!__check(['REGISTRATION_API_CALL']).status) { window.location.href = System.getPreviousPageUrl() } }}
                        >Cancel</button>
                        <button type="button" className="bs5 btn btn-primary ms-3 w145" onClick={() => !__check(['REGISTRATION_API_CALL']).status && onSubmit()}
                        > {__check(['REGISTRATION_API_CALL']).status ? <i className="fa fa-spinner fa-spin" /> : 'Submit'} </button>
                    </div>

                    <p className="d-flex mt-2 justify-content-center"> Already a customer? &nbsp;
                        <a href={System.getLoginPageUrl()} className='text-decoration-underline'>{'  '}Sign In</a>
                    </p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                    <a href={System.getPreviousPageUrl()} className='mt-3 mb-3'>Continue to Avnet Americas Home</a>
                    <a href={System.getHelpURL()} className='mt-3 mb-3'>Help</a>
                </div>
            </div>

        </div>
    )
}

export default Registration
